var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: _vm.reference,
      staticClass: "first-connexion-full-screen-modal",
      attrs: {
        id: "first-connexion-modal",
        "cancel-title": _vm.cancelButtonTitle,
        "header-class": { "first-connexion-header": this.currentStep === 4 },
        "ok-title": _vm.okButtonTitle,
        centered: "",
        "no-close-on-backdrop": "",
        "no-close-on-esc": "",
        "ok-variant": "primary"
      },
      on: { hidden: _vm.resetModal, ok: _vm.handleOk },
      scopedSlots: _vm._u([
        {
          key: "modal-header",
          fn: function(ref) {
            var close = ref.close
            return [
              _vm.currentStep < 4 || _vm.currentStep >= 5
                ? _c(
                    "div",
                    { staticClass: "first-connexion-header-content w-100" },
                    [
                      _c("div", {
                        staticClass: "first-connexion-bg-veilleur h-75"
                      }),
                      _vm._v(" "),
                      _vm.currentStep === 1
                        ? _c("img", {
                            staticClass: "first-connexion-step-img",
                            attrs: {
                              src: require("@/assets/images/b122/ic_investigator_miror.png")
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentStep === 2
                        ? _c("img", {
                            staticClass: "first-connexion-step-img",
                            attrs: {
                              src: require("@/assets/images/b122/img-watcher-right.png")
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentStep === 3
                        ? _c("img", {
                            staticClass: "first-connexion-step-img",
                            attrs: {
                              src: require("@/assets/images/b122/ic_investigator_gifts.png")
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentStep >= 5
                        ? _c("img", {
                            staticClass: "first-connexion-step-img",
                            attrs: {
                              src: require("@/assets/images/b122/img-watcher-right.png")
                            }
                          })
                        : _vm._e()
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.currentStep === 4
                ? _c(
                    "div",
                    {
                      staticClass: "first-connexion-header-content step4 w-100"
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "first-connexion-container h-100" },
                        [
                          _c(
                            "h1",
                            {
                              staticClass:
                                "page-title ml-4 first-connexion-title"
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("onboarding.valid.identity"))
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "h1",
                            {
                              staticClass:
                                "page-title mt-4 ml-4 first-connexion-subtitle"
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("onboarding.identity.unlock"))
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "first-connexion-step-img",
                        class: { "margin-bottom-15": _vm.currentStep === 4 },
                        attrs: {
                          src: require("@/assets/images/b122/img-watcher-right.png")
                        }
                      })
                    ]
                  )
                : _vm._e()
            ]
          }
        },
        {
          key: "modal-footer",
          fn: function(ref) {
            var ok = ref.ok
            var cancel = ref.cancel
            var hide = ref.hide
            return [
              _c(
                "div",
                { staticClass: "w-100 d-flex" },
                [
                  _vm.currentStep > 1 && _vm.currentStep < 4
                    ? _c(
                        "b-button",
                        {
                          staticClass: "w-100 mr-2",
                          attrs: { variant: "secondary" },
                          on: {
                            click: function($event) {
                              return _vm.handleCancel()
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "d-flex justify-content-center" },
                            [
                              _vm.currentStep < 4
                                ? _c("i", {
                                    staticClass:
                                      "ph-custom ph-caret-circle-left-bold mr-1 align-self-center"
                                  })
                                : _vm._e(),
                              _c(
                                "span",
                                {
                                  staticClass: "align-self-center mt-small-px"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.currentStep === 4
                                        ? _vm.$t("Skip")
                                        : _vm.$t("Previous")
                                    )
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "w-100",
                      attrs: { variant: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.handleOk($event)
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex justify-content-center" },
                        [
                          _c(
                            "span",
                            { staticClass: "align-self-center mt-small-px" },
                            [_vm._v(_vm._s(_vm.okButtonTitle))]
                          ),
                          _vm._v(" "),
                          _c("i", {
                            staticClass:
                              "ph-custom ph-caret-circle-right-bold ml-1 align-self-center"
                          })
                        ]
                      )
                    ]
                  )
                ],
                1
              )
            ]
          }
        }
      ])
    },
    [
      _vm._v(" "),
      _c("div", [
        _vm.currentStep === 1
          ? _c("div", [
              _c("h1", { staticClass: "page-title" }, [
                _vm._v(_vm._s(_vm.$t("onboarding.annonce.title")))
              ]),
              _vm._v(" "),
              _c("p", {
                staticClass: "first-connexion-text mt-2",
                domProps: {
                  innerHTML: _vm._s(_vm.$t("onboarding.annonce.text"))
                }
              })
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.currentStep === 2
          ? _c("div", [
              _c("h1", { staticClass: "page-title" }, [
                _vm._v(_vm._s(_vm.$t("onboarding.watcher.title")))
              ]),
              _vm._v(" "),
              _c("p", {
                staticClass: "first-connexion-text mt-2",
                domProps: {
                  innerHTML: _vm._s(_vm.$t("onboarding.watcher.text"))
                }
              })
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.currentStep === 3
          ? _c("div", [
              _c("h1", { staticClass: "page-title" }, [
                _vm._v(_vm._s(_vm.$t("onboarding.lampion.title")))
              ]),
              _vm._v(" "),
              _c("p", {
                staticClass: "first-connexion-text mt-2",
                domProps: {
                  innerHTML: _vm._s(_vm.$t("onboarding.lampion.text"))
                }
              }),
              _vm._v(" "),
              _c("p", {
                staticClass: "mt-2",
                domProps: {
                  innerHTML: _vm._s(_vm.$t("onboarding.lampion.text.info"))
                }
              })
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.currentStep === 4
          ? _c(
              "div",
              [
                _c("p", {
                  staticClass: "first-connexion-text mt-2",
                  domProps: {
                    innerHTML: _vm._s(_vm.$t("onboarding.need.identity"))
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "first-connexion-identity-info" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("validate_identity_info_1")))
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "first-connexion-identity-info-highlight" },
                    [_vm._v(_vm._s(_vm.$t("validate_identity_info_2")))]
                  )
                ]),
                _vm._v(" "),
                _c("b-form", [
                  _c("div", { staticClass: "row position-relative" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      [
                        _c(
                          "b-form-group",
                          {
                            staticClass: "mb-4",
                            attrs: {
                              "invalid-feedback":
                                _vm.identity.recto.invalidFeedback,
                              label: _vm.$t("Recto"),
                              "label-for": "recto-input"
                            }
                          },
                          [
                            _c("b-form-file", {
                              attrs: {
                                id: "recto-input",
                                "browse-text": _vm.$t("Select"),
                                "drop-placeholder": _vm.$t("drop-placeholder"),
                                placeholder: _vm.identity.recto.value
                                  ? _vm.identity.recto.value.name
                                  : "",
                                state: _vm.identity.recto.state,
                                accept: ".png, .jpeg, .jpg, .pdf",
                                required: ""
                              },
                              on: {
                                change: function($event) {
                                  return _vm.removeInvalidFeedback("recto")
                                }
                              },
                              model: {
                                value: _vm.identity.recto.value,
                                callback: function($$v) {
                                  _vm.$set(_vm.identity.recto, "value", $$v)
                                },
                                expression: "identity.recto.value"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          {
                            staticClass: "mb-4",
                            attrs: {
                              "invalid-feedback":
                                _vm.identity.verso.invalidFeedback,
                              label: _vm.$t("Verso"),
                              "label-for": "verso-input"
                            }
                          },
                          [
                            _c("b-form-file", {
                              staticClass: "custom-file",
                              attrs: {
                                id: "verso-input",
                                "browse-text": _vm.$t("Select"),
                                "drop-placeholder": _vm.$t("drop-placeholder"),
                                placeholder: _vm.identity.verso.value
                                  ? _vm.identity.verso.value.name
                                  : "",
                                state: _vm.identity.verso.state,
                                accept: ".png, .jpeg, .jpg, .pdf",
                                required: ""
                              },
                              on: {
                                change: function($event) {
                                  return _vm.removeInvalidFeedback("verso")
                                }
                              },
                              model: {
                                value: _vm.identity.verso.value,
                                callback: function($$v) {
                                  _vm.$set(_vm.identity.verso, "value", $$v)
                                },
                                expression: "identity.verso.value"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          {
                            staticClass: "mb-4 d-flex flex-row-reverse",
                            attrs: {
                              label: _vm.$t("onboarding.pass.identity"),
                              "label-for": "passIdentity-input"
                            }
                          },
                          [
                            _c("b-form-checkbox", {
                              attrs: { id: "passIdentity-input" },
                              model: {
                                value: _vm.passIdentity,
                                callback: function($$v) {
                                  _vm.passIdentity = $$v
                                },
                                expression: "passIdentity"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("p", {
                  staticClass: "main-red-color text-uppercase",
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("onboarding.pass.identity.warning")
                    )
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.currentStep >= 5
          ? _c("div", [
              _c("h1", { staticClass: "page-title" }, [
                _vm._v(_vm._s(_vm.$t("onboarding.wait.validate.title")))
              ]),
              _vm._v(" "),
              _c("p", {
                staticClass: "first-connexion-text mt-3",
                domProps: {
                  innerHTML: _vm._s(_vm.$t("onboarding.wait.validate.text"))
                }
              })
            ])
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6ef081ea", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ef081ea","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/user/FirstConnexionModal.vue
// module id = qssF
// module chunks = 0